import React from "react";
import ShopLogin from "../components/Shop/ShopLogin.jsx";

const ShopLoginPage = () => {
  return (
    <div>
      <ShopLogin />
    </div>
  );
};

export default ShopLoginPage;
